import { render, staticRenderFns } from "./CompanyProfilePage.vue?vue&type=template&id=df4849e8&scoped=true&"
import script from "./CompanyProfilePage.vue?vue&type=script&lang=js&"
export * from "./CompanyProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfilePage.vue?vue&type=style&index=0&id=df4849e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4849e8",
  null
  
)

export default component.exports